import React, { Component } from "react";
import { connect } from "react-redux";
import * as log from "loglevel";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { getMessage } from "CONFIG/i18n";

// COMPONENTS
import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import Spinner from "COMPONENTS/Spinner/Spinner";

// Action
import { startSessionAction as actionFactory } from "CONFIG/ActionFactory";

// UTILS
import { ERROR, CONFIG, queryParams } from "UTILS/Constants";

import TrailHistory from "./TrailHistory";

class TrailHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pastSessionsDetails: [],
      totalSessions: 0,
      spinnerVisibility: false,
      showTrailHistory: false
    };
  }

  componentDidMount() {
    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.go(1);
    };
    this.getPastSessionsList(
      this.props.trailHistoryData.sessionListPageSize,
      this.props.trailHistoryData.displayPage,
      this.props.trailHistoryData.searchKey
    );
  }

  setTrailHistoryData = (search, page, limit) => {
    actionFactory.setTrailHistoryData(
      {
        searchKey: search,
        displayPage: page,
        sessionListPageSize: limit
      }
    );
  }

  getPastSessionsList = (limit = 10, page = 0, search) => {
    !search &&
    this.setState({ spinnerVisibility: true });
    actionFactory.getPastSessionAction(queryParams.CLOSED, limit, page, search).then(
      (data) => {
        this.setState({
          pastSessionsDetails: data.data,
          totalSessions: data.data.total,
          spinnerVisibility: false,
          showTrailHistory: true
        });
        this.setTrailHistoryData(search, page, limit);
      },
      (error) => {
        log.error("ERROR:", error);
        if (error.code !== ERROR.NOT_AUTHORIZED) {
          toastr.error(getMessage(error.code));
        }
        this.setState({
          spinnerVisibility: false,
          showTrailHistory: true
        });
      }
    );
  };

  backToMenu = () => {
    this.props.history.push(CONFIG.path.createSession);
    this.setState({
      showTrailHistory: false
    });
  }

  render() {
    return (
      <>
        <Spinner showSpinner={this.state.spinnerVisibility} />
        { this.state.showTrailHistory && (
          <TrailHistory
            setTrailHistoryData={this.setTrailHistoryData}
            backToMenu={this.backToMenu}
            pastSessionsDetails={this.state.pastSessionsDetails}
            getPastSessionsList={this.getPastSessionsList}
            totalSessions={this.state.totalSessions}
            trailHistoryData={this.props.trailHistoryData}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.LanguageReducer.language,
  trailHistoryData: state.SessionReducer.trailHistoryData
});

export default withErrorHandler(
  connect(
    mapStateToProps
  )(TrailHistoryContainer)
);
